import { contactData } from '@/mocks/homeData';

export default function SectionContact() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <div className="w-16 h-16 mx-auto mb-5 rounded-2xl bg-primary-100 flex items-center justify-center">
            <i className="ri-mail-send-line text-2xl text-primary-600"></i>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            {contactData.title}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mb-8 max-w-xl mx-auto leading-relaxed">
            {contactData.description}
          </p>

          <div className="inline-flex flex-col sm:flex-row items-center gap-4 bg-background-50 border border-background-200/70 rounded-xl px-6 py-5">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-primary-50 flex items-center justify-center flex-shrink-0">
                <i className="ri-at-line text-lg text-primary-600"></i>
              </div>
              <span className="text-sm md:text-base text-foreground-800 font-medium">
                {contactData.email}
              </span>
            </div>
            <div className="w-px h-6 bg-background-200 hidden sm:block"></div>
            <span className="text-xs md:text-sm text-foreground-500 flex items-center gap-1.5">
              <i className="ri-time-line"></i>
              {contactData.note}
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}